import { useSelector } from 'react-redux';

export default function usePriceLevels(step) {
    const sectionslevels = useSelector(state => state.event.maps.sections.prices);
    const seatslevels = useSelector(state => state.event.maps.seats.prices);

    return seatslevels || sectionslevels;
}